<template>
  <ok-modal
    :value="value"
    size="lg"
    dialog-class="tables-modal"
    :title="page.name"
    @change="$emit('input',false)"
  >
    <validation-observer ref="form">
      <error-alert
        v-if="error"
        :error="error"
      />
      <template v-for="feature in pageFeatures">
        <div :key="feature.id">
          <h3 class="text-center my-1">
            {{ feature.name }}
          </h3>
          <b-row>
            <b-col
              md="6"
              sm="12"
            >
              <ok-date-time-picker
                v-model="feature.subscribed_at"
                :label="$t('invoice.subscribed-at')"
              />
            </b-col>
            <b-col
              md="6"
              sm="12"
            >
              <ok-date-time-picker
                v-model="feature.ends_at"
                :label="$t('page.expire-date')"
              />
            </b-col>
            <b-col md="6">
              <ok-text-input
                v-model="feature.price"
                :append="'ل.س'"
                :label="$t('invoice.cost')"
              />
            </b-col>
            <b-col
              md="6"
            >
              <ok-text-input
                v-model="feature.discount"
                :append="'ل.س'"
                :label="$t('invoice.discount')"
              />
            </b-col>
            <b-col md="6">
              <ok-text-input
                v-model.number="feature.count"
                :label="$t('invoice.count')"
              />
            </b-col>
            <b-col md="6">
              <ok-text-input
                v-if="feature.slug==='comments'"
                v-model.number="feature.daily_posts_count"
                :label="$t('page.comments-posts-number')"
              />
            </b-col>
            <b-col
              md="6"
              sm="12"
            >
              <b-form-checkbox
                v-model="feature.invoice"
                switch
              >
                {{ $t('invoice.generate') }}
              </b-form-checkbox>
              <b-form-checkbox
                v-if="feature.invoice"
                v-model="feature.paid"
                switch
              >
                {{ $t('invoice.paid') }}
              </b-form-checkbox>
            </b-col>
          </b-row>
          <hr>
        </div>
      </template>
    </validation-observer>
    <template #actions>
      <div class="d-flex justify-content-end align-items-center">
        <b-button
          variant="outline-dark"
          :disabled="loading"
          @click="submit"
        >
          <b-spinner
            v-if="loading"
            small
            class="ml-1"
          />
          {{ $t('forms.save') }}
        </b-button>
        <b-button
          variant="dark"
          class="ml-1"
          @click="$emit('input',false)"
        >
          {{ $t('forms.cancel') }}
        </b-button>
      </div>
    </template>
  </ok-modal>
</template>

<script>
import {
  BButton, BRow, BCol, BFormCheckbox,
} from 'bootstrap-vue'
import OkModal from '@/@bya3/components/modals/OkModal'
import OkDateTimePicker from '@/@bya3/components/inputs/OkDateTimePicker'
import { mapGetters } from 'vuex'
import OkTextInput from '@/@bya3/components/inputs/OkTextInput'
import ErrorAlert from '@/@bya3/components/alerts/ErrorAlert'
import { ValidationObserver } from 'vee-validate'
import PageApi from '@/api/page'

export default {
  name: 'AddFeaturesModal',
  components: {
    BFormCheckbox,
    ErrorAlert,
    OkTextInput,
    ValidationObserver,
    OkDateTimePicker,
    OkModal,
    BButton,
    BRow,
    BCol,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    page: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      error: null,
      pageFeatures: [],
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      features: 'pages/features',
    }),
  },
  watch: {
    page() {
      this.error = null
      this.setForm()
    },
  },
  mounted() {
    this.setForm()
  },
  methods: {
    async setForm() {
      this.pageFeatures = []
      const pFeatures = this.page?.features ?? []
      this.features.forEach(feature => {
        const existFeature = pFeatures.find(f => f.id === feature.id)
        this.pageFeatures.push({
          feature_id: feature.id,
          price: existFeature?.price ?? 0,
          discount: existFeature?.discount ?? 0,
          count: existFeature?.count ?? 0,
          subscribed_at: existFeature?.subscribed_at ?? '',
          ends_at: existFeature?.ends_at ?? '',
          name: feature?.name ?? '',
          slug: feature?.slug ?? '',
          daily_posts_count: existFeature?.daily_posts_count ?? 1,
        })
      })
    },
    async submit() {
      this.error = null
      const valid = await this.$refs.form.validate()
      if (!valid) {
        this.error = this.$tc('errors.field-invalid', 2)
        this.notifyError = this.$tc('errors.field-invalid', 2)
      } else {
        this.loading = true
        const form = { features: this.pageFeatures }
        await PageApi.updatePageFeatures(this.page.id, form).then(res => {
          if (res.error === 0) {
            this.$notifySuccess(res.message)
            this.$emit('updated')
            this.$emit('input', false)
          }
        }).catch(e => { this.error = e })
          .finally(() => { this.loading = false })
      }
    },
  },
}
</script>
